module.exports = __webpack_public_path__ + "img/gb95-85______16.prt.9de1ad17.jpg";